import {
  BankAccountCheckerLog,
  BankAccountCheckerLogLevel,
  BankAccountCheckerResult,
} from '../../../workers/BankAccountChecker';
import { PopperButton } from '../../buttons/PopperButton';
import React, { ReactNode } from 'react';
import {
  Check,
  Error,
  ExpandLess,
  ExpandMore,
  Info,
  Loop,
  Warning,
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { Box, List, ListItemIcon, ListItemText } from '@mui/material';

import ListItemButton from '@mui/material/ListItemButton';

export interface AccountCheckerPopperProps {
  checkerResult: BankAccountCheckerResult | null;
  onLogClicked?: (log: BankAccountCheckerLog) => void;
}

const LogLevelIcon = ({
  logLevel,
}: {
  logLevel: BankAccountCheckerLogLevel;
}) => {
  const theme = useTheme();
  switch (logLevel) {
    case BankAccountCheckerLogLevel.ERROR:
      return <Error color={'error'} />;
    case BankAccountCheckerLogLevel.WARNING:
      return <Warning htmlColor={theme.palette.warning.main} />;
    case BankAccountCheckerLogLevel.INFO:
      return <Info htmlColor={theme.palette.info.main} />;
  }
};

export const AccountCheckerPopper = (props: AccountCheckerPopperProps) => {
  const { checkerResult, onLogClicked } = props;
  const theme = useTheme();

  return (
    <PopperButton
      buttonContent={(expanded) => {
        const expandIcon = expanded ? <ExpandLess /> : <ExpandMore />;
        let content: ReactNode;
        if (checkerResult == null) {
          content = <Loop />;
        } else {
          const errorsCount = checkerResult.logs.filter(
            (log) => log.level === BankAccountCheckerLogLevel.ERROR,
          ).length;
          const warningCount = checkerResult.logs.filter(
            (log) => log.level === BankAccountCheckerLogLevel.WARNING,
          ).length;
          if (errorsCount === 0 && warningCount === 0) {
            content = (
              <Check
                htmlColor={theme.palette.success.main}
                sx={{ marginRight: 1 }}
              />
            );
          } else {
            content = (
              <>
                {errorsCount > 0 ? (
                  <>
                    <LogLevelIcon logLevel={BankAccountCheckerLogLevel.ERROR} />{' '}
                    <Box component="span" sx={{ marginRight: 1 }}>
                      {errorsCount}
                    </Box>
                  </>
                ) : null}
                {warningCount > 0 ? (
                  <>
                    <LogLevelIcon
                      logLevel={BankAccountCheckerLogLevel.WARNING}
                    />{' '}
                    <Box component="span" sx={{ marginRight: 1 }}>
                      {warningCount}
                    </Box>
                  </>
                ) : null}
              </>
            );
          }
        }
        return (
          <>
            {content} {expandIcon}
          </>
        );
      }}
    >
      {checkerResult != null ? (
        checkerResult.logs.length > 0 ? (
          <List sx={{ overflow: 'auto', maxHeight: 250 }} dense={true}>
            {checkerResult.logs.map((log, index) => (
              <ListItemButton key={index} onClick={() => onLogClicked?.(log)}>
                <ListItemIcon>
                  <LogLevelIcon logLevel={log.level} />
                </ListItemIcon>
                <ListItemText>
                  Ligne n°{log.line + 1} : {log.message}
                </ListItemText>
              </ListItemButton>
            ))}
          </List>
        ) : (
          'Pas de problèmes.'
        )
      ) : (
        'Chargement...'
      )}
    </PopperButton>
  );
};
